import { render, staticRenderFns } from "./IngresarLiquidacion.vue?vue&type=template&id=9b8dd878&"
import script from "./IngresarLiquidacion.vue?vue&type=script&lang=js&"
export * from "./IngresarLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports